// extracted by mini-css-extract-plugin
export default {"ModeratorInvitationListItem":"bcg_a bhh_a bhh_r bhh_j","ModeratorInvitationListItem__left":"bcg_b bhh_a bhh_j","ModeratorInvitationListItem__note":"bcg_c bhh_fm"};